module.exports = __webpack_public_path__ + "img/dcim02.2a927c16.jpg";